<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>

    <side-bar
      :sidebar-item-color="sidebarBackground"
      :sidebar-background-image="sidebarBackgroundImage"
    >
      <mobile-menu slot="content"></mobile-menu>

      <!-- <sidebar-link to="">
        <md-icon>data_usage</md-icon>
        <p>Common</p>
        <sidebar-link to="/common_page">
          <md-icon>message</md-icon>
          <p>Common Page</p>
        </sidebar-link>
      </sidebar-link>
      <sidebar-link to="/salesidol_table">
        <md-avatar>
          <img src="@/assets/img/salesidol_logo.png" alt="Avatar" />
        </md-avatar>
        <p>Salesidol</p>
      </sidebar-link>
      <sidebar-link to="/mayai_table">
        <md-avatar>
          <img src="@/assets/img/mayai_logo.png" alt="Avatar" />
        </md-avatar>
        <p>Mayai</p>
      </sidebar-link> -->

      <template slot="links">
        <sidebar-item
          :link="{
            name: 'Common',
            icon: 'supervised_user_circle'
          }"
        >
          <!-- <div class="menu-spliter"></div> -->
          <sidebar-item
            :link="{
              name: 'Status',
              icon: 'info',
              path: '/common_page'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'NG Word',
              icon: 'edit_note',
              path: '/ng_word'
            }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Salesidol',
            icon: 'supervised_user_circle'
          }"
        >
          <!-- <div class="menu-spliter"></div> -->
          <sidebar-item
            :link="{
              name: 'Salesidol',
              icon: 'perm_phone_msg',
              path: '/salesidol_table'
            }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Mayai',
            icon: 'supervised_user_circle'
          }"
        >
          <!-- <div class="menu-spliter"></div> -->
          <!-- <sidebar-item
            :link="{
              name: 'Mayai List',
              icon: 'voicemail',
              path: '/mayai_table'
            }"
          ></sidebar-item> -->
          <sidebar-item
            :link="{
              name: 'Mayai Customer List',
              icon: 'voicemail',
              path: '/mayai_customer_list'
            }"
          ></sidebar-item>
          <!-- <sidebar-item
            :link="{
              name: 'Mayai Status',
              icon: 'edit_note',
              path: '/update_mayai_status'
            }"
          ></sidebar-item> -->
          <sidebar-item
            :link="{
              name: 'Mayai Reports',
              icon: 'article',
              path: '/mayai_reports'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'Mayai Reports (Beta)',
              icon: 'article',
              path: '/mayai_daily_reports'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'Number manager',
              icon: 'phone',
              path: '/number_pool'
            }"
          ></sidebar-item>
        </sidebar-item>
      </template>
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>

      <!-- <fixed-plugin
        :color.sync="sidebarBackground"
        :image.sync="sidebarBackgroundImage"
      >
      </fixed-plugin> -->

      <dashboard-content> </dashboard-content>
    </div>
  </div>
</template>

<script>
import TopNavbar from "./TopNavbar.vue";
// import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "@/pages/Layout/MobileMenu.vue";
// import FixedPlugin from "./Extra/FixedPlugin.vue";
// import SidebarLink from "../../components/SidebarPlugin/SidebarLink.vue";

export default {
  components: {
    TopNavbar,
    DashboardContent,
    // ContentFooter,
    MobileMenu
    // FixedPlugin,
    // SidebarLink
  },
  data() {
    return {
      sidebarBackground: "pink",
      sidebarBackgroundImage: require("@/assets/img/sidebar-4.jpg")
    };
  }
};
</script>
